import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type {ReactNode, Ref} from "react";
import {forwardRef} from "react";

import {memoWithType} from "../../react";
import {HStack, type HStackRef} from "../ui/hstack";
import {Spinner} from "../ui/spinner";
import {Text} from "../ui/text";

export type Props = {
    className?: string;
    /**
     * this requires parent element has to be `{flex: 1}`
     */
    center?: boolean;
    children?: ReactNode;
};

const style = tva({
    base: "space-x-1.5 justify-center items-center",
    variants: {
        center: {
            true: "w-full h-full flex-grow flex-shrink"
        }
    }
});

const Loader = forwardRef<HStackRef, Props>(function Loader({center, className, children}, ref) {
    return (
        <HStack ref={ref} className={style({center, className})} testID="loader">
            <Spinner />
            <Text color="blueGray.800" variant="sm">
                {children}
            </Text>
        </HStack>
    );
}) as {
    <T = never>(props: Props & {ref?: Ref<HStackRef<T>>}): React.ReactElement;
    displayName: string;
};

export default memoWithType(Loader);
